import React, { useState } from 'react';
import { Header } from '../../components';
import Sidebar from './Sidebar';
import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const toggleSidebarExpand = () => setSidebarExpanded((prev) => !prev);

  return (
    <div className="dashboard-layout">
      <Sidebar
        isOpen={sidebarOpen}
        isExpanded={sidebarExpanded}
        onClose={() => setSidebarOpen(false)}
        onToggle={toggleSidebar}
        onToggleExpand={toggleSidebarExpand}
      />
      <div
        className={`dashboard-main ${sidebarOpen ? 'sidebar-open' : ''} ${
          sidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'
        }`}
      >
        <Header onMenuToggle={toggleSidebar} />
        <main className="dashboard-content">{children}</main>
      </div>
    </div>
  );
};

export default DashboardLayout;
